import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { INormalisedResult } from '../../../core/interfaces/interfaces';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { Control } from '../control/control.model';
import { Group } from '../group/group.model';
import { RestrictedAccountObjectFacade } from '../restricted-account-object/restricted-account-object.facade';
import { FormApiFacade } from './form.api-facade';
import { Form } from './form.model';
import { FormStoreFacade } from './form.store-facade';

export class FormFacade extends RestrictedAccountObjectFacade<Form, FormApiFacade, FormStoreFacade> {

    /**
     * In this override we purposely ignore the options argument because the if
     * we specify x-modified-since header the api will only returns the groups
     * and controls that changed. When this happens we will get a partial Form,
     * if we submit this to our store as partial it means we will detach Groups
     * from the Form. For example:
     *
     * Say we have Form with Group A and Group B, if we recently attached
     * Group C, and we call the forms endpoint with x-modified-since, we'll get
     * back a Form with {... groups: [group-c-id]} (because it's the only one
     * that changed)
     * @inheritDoc
     */
    syncAll(options?: ApiRequestOptions, accountId?: string): Observable<any> {
        return (
            accountId ?
                of(accountId) :
                this.appFacade.objects.account.store.getActive()
                    .take(1)
                    .map(account => account && account.id)
        )
            .concatMap(id =>
                id ? this.syncAllByAccount(id) : of()
            )
            .catch(error => this.handleSyncError(error));
    }

    protected updateStore(remote: Array<Form>): void {

        const entities = remote
            .reduce((p, c) => {

                const result: INormalisedResult =
                    this.appFacade.normalizer.normalize(
                        c,
                        this.getSchema()
                    );

                p.form = p.form.concat(Object.values(result.form.entities));

                if (result.group) {
                    p.group = p.group.concat(
                        Object.values(result.group.entities)
                    );
                }

                if (result.control) {
                    p.control = p.control.concat(
                        Object.values(result.control.entities)
                            .map(control => new Control(control))
                    );
                }

                return p;

            }, {
                control: [] as Array<Control>,
                form: [] as Array<Form>,
                group: [] as Array<Group>
            });

        this.store.updateFromApi(entities);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/form/form.facade.ts